import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import history from "./history";
import Keys from "@utils/keys";

/* Google  Analytics */
import ReactGA from "react-ga";

const trackingCode = Keys.GOOGLE.ANALYTICS.TRACKING_CODE;
window.location.hostname === "localhost"
//@ts-ignore
  ? ReactGA?.initialize(trackingCode, { cookieDomain: "none" })
  : ReactGA?.initialize(trackingCode);
/* Google  Analytics */

function Routes(props: React.ComponentProps<"div">) {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return <RouterProvider router={router}></RouterProvider>;
}

export { history };
export default Routes;
